export default __webpack_public_path__ + "44b33aba67d2752138fc28ffbb4e83d0.png";